import { transformWithSpec } from "../../../utils/response.js";
function termConditions(builder) {
  return {
    getTermConditions: builder.query({
      providesTags: ["term-conditions"],
      query: () => ({
        url: `/member/terms-and-conditions`,
        method: "GET"
      }),
      transformResponse: transformWithSpec()
    })
  };
}
export {
  termConditions as default
};
